<script>
import httpService from "@/core/api/request";
export default {
  data: function() {
    return {
      cuponStatus: null,
      cuponTypes: null,
      cuponUsages: null
    };
  },
  methods: {
    getCuponStatus: function() {
      let httpRequest = {
        params: "",
        module: "discount_status"
      };
      this.get(httpRequest)
        .then(cuponStatus => {
          this.cuponStatus = cuponStatus.data;
        })
        .catch(() => {
          this.cuponStatus = null;
        });
    },
    getCuponTypes: function() {
      let httpRequest = {
        params: "",
        module: "discount_types"
      };
      this.get(httpRequest)
        .then(cuponTypes => {
          this.cuponTypes = cuponTypes.data;
        })
        .catch(() => {
          this.cuponTypes = null;
        });
    },
    getCuponUsages: function() {
      let httpRequest = {
        params: "",
        module: "discount_usages"
      };
      this.get(httpRequest)
        .then(cuponUsages => {
          this.cuponUsages = cuponUsages.data;
        })
        .catch(() => {
          this.cuponUsages = null;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/discount_cupons/mixins.vue